export default {
  isShown: (state) => state.isShown,
  editId: (state) => state.editId,
  pagesList: (state) => state.pagesList,
  isPageEditable: (state) => state.isPageEditable,
};
